import React, { useEffect, useState, useRef } from 'react';
import KeyRegisterAllotAfso from './KeyRegisterAllotAfso';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const KeyRegisterAllotDist_data = async (params) => {
    const response = await fetch(
        `${process.env.REACT_APP_URL_ALLOTMENT}/KeyRegister/get_dist_keyreg_allot`,
        {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(params),
        }
    );
    if (!response.ok) throw new Error('Failed to fetch data');
    return response.json();
};

const KeyRegisterAllotDist = ({ month, year, comm_id, heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const [renderContentt, setRenderContentt] = useState(null);

    const detailsRRef = useRef(null);

    const [nfsaSchemeList, setNfsaSchemeList] = useState([]);
    const [stateSchemeList, setStateSchemeList] = useState([]);

    const handleDistClick = (month, year, comm_id, dist_code, heading) => {
        setRenderContentt(null);
        setTimeout(() => {
            setRenderContentt(
                <KeyRegisterAllotAfso
                    month={month}
                    year={year}
                    comm_id={comm_id}
                    dist_code={dist_code}
                    heading={heading}
                />
            );
        }, 10);
    };

    /* ================= FETCH DATA ================= */
    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await KeyRegisterAllotDist_data({
                    month,
                    year,
                    comm_id,
                    heading,
                });

                setTabHeading(response_data.heading);

                if (response_data.data?.length > 0) {
                    setReportData(response_data.data);

                    const nfsa = [];
                    const state = [];

                    response_data.data.forEach(item => {
                        (item.schemeWrapperList || []).forEach(s => {
                            if (s.nfsaSchemeList) nfsa.push(...s.nfsaSchemeList);
                            if (s.stateSchemeList) state.push(...s.stateSchemeList);
                        });
                    });

                    setNfsaSchemeList(
                        Array.from(new Map(nfsa.map(s => [s.scheme_id, s])).values())
                    );
                    setStateSchemeList(
                        Array.from(new Map(state.map(s => [s.scheme_id, s])).values())
                    );
                } else {
                    setReportData([]);
                }
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, comm_id, heading]);

    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsRRef.current) {
            detailsRRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [loading, error, reportData]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return <div className="mainhead" align="center">Internal Error</div>;
    }

    if (!reportData.length) {
        return <div className="mainhead" align="center">No data found</div>;
    }

    /* ================= TOTAL CALCULATION ================= */

    const allSchemes = [...nfsaSchemeList, ...stateSchemeList];

    const totals = {
        total_Cards: 0,
        total_units: 0,
        totalAllottedQty: 0,
        schemes: {}
    };

    // initialize scheme totals as NUMBER
    allSchemes.forEach(s => {
        totals.schemes[s.scheme_id] = 0;
    });

    reportData.forEach(item => {
        totals.total_Cards += item.total_Cards || 0;
        totals.total_units += item.total_units || 0;

        let rowTotal = 0;

        allSchemes.forEach(scheme => {
            let qty = 0;

            (item.schemeWrapperList || []).forEach(w => {
                const nf = (w.nfsaSchemeList || []).find(
                    n => n.scheme_id === scheme.scheme_id
                );
                const st = (w.stateSchemeList || []).find(
                    n => n.scheme_id === scheme.scheme_id
                );

                if (nf) qty = nf.alloted_qty || 0;
                if (st) qty = st.alloted_qty || 0;
            });

            totals.schemes[scheme.scheme_id] += qty;
            rowTotal += qty;
        });

        totals.totalAllottedQty += rowTotal;
    });

    /* ================= RENDER ================= */
    return (
        <>
            <table align="center" width="90%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={allSchemes.length * 2 + 5}>{tabHeading}</th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>District</th>
                        <th rowSpan={2}>Total Cards</th>
                        <th rowSpan={2}>Total Unit</th>
                        {/* <th colSpan={nfsaSchemeList.length * 2}>NFSA (kgs)</th>
                        <th colSpan={stateSchemeList.length * 2}>STATE (kgs)</th>  */}

                        {nfsaSchemeList?.length > 0 && (
                            <th colSpan={nfsaSchemeList.length * 2}>NFSA</th>
                        )}

                        {stateSchemeList?.length > 0 && (
                            <th colSpan={stateSchemeList.length * 2}>Non-NFSA</th>
                        )}

                        <th rowSpan={2}>Total<br />Allotment <br /> (Kgs)</th>
                    </tr>
                    <tr className="tableheader">
                        {nfsaSchemeList.map((s, i) => (
                            <th colSpan={2} key={i}>{s.scheme_short_name}</th>
                        ))}
                        {stateSchemeList.map((s, i) => (
                            <th colSpan={2} key={'s' + i}>{s.scheme_short_name}</th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {reportData.map((item, index) => (
                        <tr key={item.dist_code}>
                            <td align="center">{index + 1}</td>
                            <td>
                                <a
                                    style={{ cursor: 'pointer', color: 'blue' }}
                                    onClick={() =>
                                        handleDistClick(month, year, comm_id, item.dist_Code, tabHeading)
                                    }
                                >
                                    {item.dist_name_en}
                                </a>
                            </td>

                            <td align="right">{item.total_Cards}</td>
                            <td align="right">{item.total_units}</td>

                            {allSchemes.map((scheme, i) => {
                                let qty = 0;

                                (item.schemeWrapperList || []).forEach(w => {
                                    const nf = (w.nfsaSchemeList || []).find(
                                        n => n.scheme_id === scheme.scheme_id
                                    );
                                    const st = (w.stateSchemeList || []).find(
                                        n => n.scheme_id === scheme.scheme_id
                                    );

                                    if (nf) qty = nf.alloted_qty || 0;
                                    if (st) qty = st.alloted_qty || 0;
                                });

                                return (
                                    <td key={i} colSpan={2} align="right">{qty}</td>
                                );
                            })}

                            <td align="right">{Number(item.totalAllottedQty).toFixed(2)}</td>
                        </tr>
                    ))}

                    {/* TOTAL ROW */}
                    <tr className="tableheader">
                        <td colSpan={2} align="right">Total:</td>
                        <td align="right">{totals.total_Cards}</td>
                        <td align="right">{totals.total_units}</td>

                        {allSchemes.map((s, i) => (
                            <td key={i} colSpan={2} align="right">
                                {Number(totals.schemes[s.scheme_id]).toFixed(2)}
                            </td>
                        ))}

                        <td align="right">{totals.totalAllottedQty}</td>
                    </tr>
                </tbody>
            </table>
            <br /><br /> <br />
            <div ref={detailsRRef}>{renderContentt}</div>
        </>
    );
};
export default KeyRegisterAllotDist;
